import AuthBox from "../../Box/AuthBox";
import styles from "./style.module.css";
import { useState, useRef } from "react";
import cn from "classnames";
import ReactPaginate from "react-paginate";
import { ReactComponent as RedArrow } from "../../../assets/redarrowright.svg";
import { Link } from "react-router-dom";

const TechnicianDatabaseTable = ({ className, technicians, getHandlePageClick, totalPageCount, setSearching, searching, ...props }) => {
  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState("");

  const [paginate, setPaginate] = useState(0);
  const [pageData, setPageData] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);

  const handlePageClick = (data) => {
    let selected = data.selected;
    setPaginate(selected);
    setPageData(technicians.slice(selected * 10, selected * 10 + 10));
    getHandlePageClick(selected + 1);
  };

  const handleClickKeyDown = (e) => {
    if (e.key === "Enter") {
      setPageData(technicians.slice((Number(e.target.value) - 1) * 10, (Number(e.target.value) - 1) * 10 + 10));
      setPaginate(Number(e.target.value) - 1);
      getHandlePageClick(Number(e.target.value));
    }
  };

  return (
    <div className={[styles.tableCont, className].join(" ")} {...props}>
      <AuthBox className={styles.authBox}>
        <input
          className={styles.input}
          placeholder="İsim Soyisim, Kullanıcı adı, Telefon Numarası"
          value={searching == "all" ? "" : searching}
          onChange={(e) => setSearching(e.target.value)}
        />
      </AuthBox>
      <AuthBox className={styles.authBox2}>
        <div className={styles.tableInside}>
          <div className={styles.titles}>
            <div className={styles.title1}>Kontrol Numarası</div>
            <div className={styles.title2}>Kontrol Sağlayan Personel</div>
            <div className={styles.title3}>Tarih</div>
            <div className={styles.title4}>Durumu</div>
            {/* <div className={styles.title5}>Saat</div> */}
          </div>
          <div className="flex flex-col w-full mt-5  gap-2">
            {technicians &&
              technicians.map((technician, index) => (
                <div className={cn(styles.datas, index % 2 === 0 ? styles.datas2 : null)} key={index}>
                  <Link
                    className={[
                      styles.data1,
                      "font-semibold hover:opacity-80 transition-all duration-100",
                      technician?.status ? "text-green-500" : "text-red-600",
                    ].join(" ")}
                    to={`/personel/teknik-kontrol-anketi/${technician?.requirements_id}`}
                  >
                    {technician?.control_number}
                  </Link>
                  <div className={styles.data2}>{technician?.personel_name}</div>
                  <div className={styles.data3}>{technician?.date}</div>
                  <div className={styles.data4}>
                    {technician?.status ? (
                      <span className="text-green-500">Tamamlandı</span>
                    ) : (
                      <span className="text-red-600">Tamamlanmadı</span>
                    )}
                  </div>
                  {/* <div className={styles.data5}>
                    {technician?.start_time?.substring(0, 5) +
                      "-" +
                      technician?.end_time?.substring(0, 5)}
                  </div> */}
                </div>
              ))}
          </div>
        </div>
      </AuthBox>

      <div className={styles.paginateContainer}>
        <ReactPaginate
          className={styles.paginate}
          breakLabel="..."
          nextLabel=">"
          previousLabel="<"
          nextLinkClassName="text-primary"
          previousLinkClassName="text-primary"
          nextClassName={styles.pageNextClassname}
          previousClassName={styles.pagePreviousClassname}
          onPageChange={(e) => handlePageClick(e)}
          pageRangeDisplayed={5}
          pageCount={totalPageCount}
          renderOnZeroPageCount={false}
          forcePage={paginate}
          pageClassName={styles.pageClassname}
          activeClassName={styles.activeClassname}
        />
        {
          <div className={styles.paginateGitContainer}>
            <label htmlFor="Git" className="text-primary">
              Git
            </label>
            <input
              autoComplete="off"
              ref={inputRef}
              maxLength="3"
              placeholder="1"
              className={styles.paginateGitInput}
              type="text"
              id="Git"
              onKeyDown={(e) => {
                handleClickKeyDown(e);
              }}
            />
            <button /*onClick={(e)=> handleClick(e)} */>
              <RedArrow width="1.5em" height="1.5em" className="absolute right-1 top-[5px] text-primary" />
            </button>
          </div>
        }
      </div>
    </div>
  );
};

export default TechnicianDatabaseTable;
